
import { conceptsPropertyContext } from '@/pages/property/concepts'
import { useContext } from 'react'
import { PropertySearchForm } from './PropertySearchForm'

export const ConceptsPropertySearch = () => {
  const { updateFilter, filter } = useContext(conceptsPropertyContext)

  return (
    <PropertySearchForm
      filter={filter}
      onSubmit={updateFilter}
      listType='opened' />
  )
}
